<template>
  <div class="video_box_s">
    <div class="video_box">
      <div class="audiotitlex">
        <div class="img_box">
          <img class="img_box" src="@/assets/icon/tupi.png" />
        </div>
        <div class="fileName_box">
          {{ fileName }}
        </div>
      </div>
      <div class="_box">
        <div class="image_box_row">
          <img class="img_" src="@/assets/icon/zipbao.png" />
          <div class="text_">{{ fileName }}</div>
          <div class="text_">
            <el-button type="primary" size="small" @click="zipread"
              >立即下载</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
} from "@/api/special/special";
import { checkIsBuy } from "@/api/bookstore/bookstore";
import { OuchnOss } from "@/plugins/OuchnOss";
export default {
  data() {
    return {
      fileName: "",
      goodsId: this.$route.query.goodsId, //需要传递的参数
      filesId: "", //需要传递的参数(资源文件id)
      goodsFilePath: "", //需要传递的参数(资源文件路径)
      bookdetail: {}, //基本信息
      sourceList: [], //文件信息
      readdefault: 0, //默认阅读第一个
      item: undefined,
      index: undefined,
      srcList: [],
      ouchnoss1: null,
      loading: false,
      setInterval2: undefined,
      TimeParameter: 10, //更新频次-单位分钟
    };
  },
  created() {
    this.stopEvent();
    this.ouchnoss1 = new OuchnOss(true);
  },
  destroyed() {
    this.closeTime();
  },
  methods: {
    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;
        this.setInterval2 = setInterval(() => {
          this.updateOcDownloadReading(); //更新阅读时长
        }, this.TimeParameter * 60000);
      });
    },
    closeTime() {
      clearInterval(this.setInterval2);
      this.setInterval2 = null;
    },
    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.filesId,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {});
    },
    zipread() {
      if (this.goodsFilePath != "") {
        this.ouchnoss1.downloadByUrl(this.goodsFilePath, this.fileName);
      }
    },
    //禁用右键
    stopEvent() {
      document.oncontextmenu = function (e) {
        return false;
      };
    },
    tabbook(item) {
      this.fileName = item.sourceName;
      this.filesId = item.filesId;
      this.loading = this.$loading({
        lock: true,
      });
      selectFileLinkAndReadingLocation({
        goodsFileId: item.filesId,
        fileType: item.fileType,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {
        this.loading.close();
        let data = res.data;
        if (data) {
          this.buys(item, data);
        }
      });
    },
    buys(item, data) {
      //判断是否购买该商品
      this.payType = this.$route.query.payType
        ? this.$route.query.payType
        : "goods";
      checkIsBuy({
        relevanceId: this.goodsId,
        type: this.payType,
      }).then((res) => {
        if (data.hasPermission) {
          //有权限
          this.goodsFilePath = data.filePath;
          this.selectTimeParameter(); //获取更新进度和时长的频次   循环调用更新时长和更新进度方法
        } else if (res.data == "1" && item.sourceStatus == "2") {
          this.Trial = true; //试读
          this.goodsFilePath = data.filePath;
        } else {
          //无权限
          this.goodsFilePath = "";
          this.checkIsBuys();
        }
      });
    },
    checkIsBuys() {
      //无权限走购买流程
      this.$alert("该文件需要购买后才能阅读，是否确认购买", "购买", {
        confirmButtonText: "立即购买",
        callback: (action) => {
          if (action === "cancel") {
            return;
          }
          let userId = this.$store.getters.userId;
          if (!userId) {
            this.$store.commit("SET_REDIRECTPARAMS", {
              goodsId: this.$route.query.goodsId,
              relevanceId: this.$route.query.relevanceId,
              resource: this.$route.query.resource,
              resourceType: this.$route.query.resourceType,
            });
            this.$router.push({
              path: "/login",
              query: {
                redirectPath: "/onlineReading",
              },
            });
          } else {
            //判断是否购买该商品
            this.payType = this.$route.query.payType
              ? this.$route.query.payType
              : "goods";
            checkIsBuy({
              relevanceId: this.goodsId,
              type: this.payType,
            }).then((res) => {
              console.log("是否已购买响应", res);
              if (res.data === "2") {
                this.$message.error("数据异常");
                return;
              }
              if (res.data === "1") {
                this.$router.push({
                  path: "/submitOrder/index",
                  query: {
                    id: this.$route.query.goodsId,
                    from: "bookstore",
                  },
                });
              } else {
                this.$message("该商品已购买无需重复购买");
              }
            });
          }
        },
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.video_box_s {
  overflow: hidden;
}
.video_box {
  width: 100%;
  min-height: 95vh;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  background: #fffefd;
}

.video_boxt {
  width: 100%;
  float: left;
  font-size: 14px;
  padding: 0 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 41px;
  margin-bottom: 30px;
  height: 41px;
  border-bottom: 1px solid #f2f2f2;
}

.video_con {
  width: 1320px;
  margin: 0 auto;
  margin-bottom: 30px;
  overflow: hidden;
  min-height: 430px;
  position: relative;
  .el-image {
    max-width: 100%;
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
  }
}
.img_box {
  width: 20px;
  height: 20px;
}
.audiotitlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 15px;
  border-bottom: 1px solid #f2f2f2;
  padding: 5px;
}
.fileName_box {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}
._box {
  width: 100%;
  margin: 0 auto;
}
.row_box {
  width: 500px;
  margin: 0 auto;
}
.img_ {
  width: 150px;
  height: 150px;
  margin: 200px auto 0 auto;
}
.text_ {
  text-align: center;
  margin-top: 10px;
}
.image_box_row {
  width: 150px;
  margin: 0 auto;
}
</style>